export const progressTitle = [
  'สมัครเข้าอบรม',
  'อัปเดทข้อมูล',
  'ยืนยันข้อมูลสมัครเข้าอบรม',
]

export const type = [
  { label: 'บริษัท', index: 'COMPANY' },
  { label: 'สมาคม', index: 'ASSOCIATION' },
  { label: 'อื่นๆ', index: 'OTHER' },
]

export const TYPE_ENUM = {
  COMPANY: 'บริษัท',
  ASSOCIAITON: 'สมาคม',
  OTHER: 'อื่นๆ',
}

export const genderTitle = {
  ช: 'ชาย',
  ญ: 'หญิง',
}

export const prefixOptions = [
  { value: 'นาย', label: 'นาย' },
  { value: 'นาง', label: 'นาง' },
  { value: 'นางสาว', label: 'นางสาว' },
  { value: 'ว่าที่ร้อยตรีหญิง', label: 'ว่าที่ร้อยตรีหญิง' },
  { value: 'ว่าที่ร้อยตรี', label: 'ว่าที่ร้อยตรี' },
  { value: 'สิบเอก', label: 'สิบเอก' },
  { value: 'ดาบตำรวจ', label: 'ดาบตำรวจ' },
  { value: 'จ่าสิบเอก', label: 'จ่าสิบเอก' },
  { value: 'สิบเอกหญิง', label: 'สิบเอกหญิง' },
  { value: 'ว่าที่ร้อยโท', label: 'ว่าที่ร้อยโท' },
  { value: 'จ่าสิบตำรวจ', label: 'จ่าสิบตำรวจ' },
  { value: 'สิบตรี', label: 'สิบตรี' },
  { value: 'สิบตำรวจเอก', label: 'สิบตำรวจเอก' },
  { value: 'ร้อยตำรวจตรี', label: 'ร้อยตำรวจตรี' },
  { value: 'พันตำรวจโท', label: 'พันตำรวจโท' },
  { value: 'จ่าสิบตรี', label: 'จ่าสิบตรี' },
  { value: 'ร้อยตรี', label: 'ร้อยตรี' },
  { value: 'พันจ่าอากาศเอก', label: 'พันจ่าอากาศเอก' },
  { value: 'จ่าสิบเอกหญิง', label: 'จ่าสิบเอกหญิง' },
  { value: 'ร้อยตำรวจเอก', label: 'ร้อยตำรวจเอก' },
  { value: 'พันตรี', label: 'พันตรี' },
  { value: 'ดาบตำรวจหญิง', label: 'ดาบตำรวจหญิง' },
  { value: 'สิบโทหญิง', label: 'สิบโทหญิง' },
  { value: 'สิบโท', label: 'สิบโท' },
  { value: 'สิบตำรวจตรี', label: 'สิบตำรวจตรี' },
  { value: 'พันเอก', label: 'พันเอก' },
  { value: 'พันตำรวจโทหญิง', label: 'พันตำรวจโทหญิง' },
  { value: 'จ่าอากาศตรี', label: 'จ่าอากาศตรี' },
  { value: 'สิบตำรวจโท', label: 'สิบตำรวจโท' },
  { value: 'เรือเอกหญิง', label: 'เรือเอกหญิง' },
  { value: 'ร้อยเอก', label: 'ร้อยเอก' },
  { value: 'ร้อยโท', label: 'ร้อยโท' },
  { value: 'พันตำรวจเอก', label: 'พันตำรวจเอก' },
  { value: 'พันจ่าเอก', label: 'พันจ่าเอก' },
  { value: 'จ่าเอก', label: 'จ่าเอก' },
  { value: 'จ่าตรี', label: 'จ่าตรี' },
  { value: 'จ่าสิบตรีหญิง', label: 'จ่าสิบตรีหญิง' },
  { value: 'สิบตำรวจตรีหญิง', label: 'สิบตำรวจตรีหญิง' },
  { value: 'ว่าที่ร้อยเอก', label: 'ว่าที่ร้อยเอก' },
  { value: 'ว่าที่พันตรี', label: 'ว่าที่พันตรี' },
  { value: 'เรืออากาศตรี', label: 'เรืออากาศตรี' },
  { value: 'พลทหาร', label: 'พลทหาร' },
  { value: 'นาวาตรี', label: 'นาวาตรี' },
  { value: 'จ่าสิบตำรวจหญิง', label: 'จ่าสิบตำรวจหญิง' },
  { value: 'หม่อมหลวง', label: 'หม่อมหลวง' },
  { value: 'ว่าที่เรือตรี', label: 'ว่าที่เรือตรี' },
  { value: 'ว่าที่ร้อยตำรวจตรี', label: 'ว่าที่ร้อยตำรวจตรี' },
  { value: 'เรือเอก', label: 'เรือเอก' },
  { value: 'เรือโทหญิง', label: 'เรือโทหญิง' },
  { value: 'ร้อยตำรวจโทหญิง', label: 'ร้อยตำรวจโทหญิง' },
  { value: 'ร้อยตำรวจโท', label: 'ร้อยตำรวจโท' },
  { value: 'ร้อยตำรวจเอกหญิง', label: 'ร้อยตำรวจเอกหญิง' },
  { value: 'จ่าอากาศเอก', label: 'จ่าอากาศเอก' },
]

export const optionPrefix = [
  { label: 'Mr', value: 'Mr' },
  { label: 'Ms', value: 'Ms' },
  { label: 'Mrs', value: 'Mrs' },
]

export const USER_TYPE = {
  AGENT: 'AGENT',
  PROSPECT: 'PROSPECT',
  TEMP: 'TEMP',
  STAFF: 'STAFF',
}
